/** Staging uses the HTTPS frontend proxy, regardless of an old build-time API setting. */
export function resolveApiBaseUrl(hostname: string, configuredBaseUrl?: string): string {
  if (hostname === "staging.easybar.co.il") return "/api/";
  return configuredBaseUrl || "http://77.68.49.169/api/";
}
